import { IMockConfig, IMockData } from './mock.type';
export const MOCK_DEFULAT_CONFIG: IMockConfig = {
  data: null,
  log: true,
  ignoreOtherInterceptors: false,
  interceptors: {
    response: (res) => res
  }
};

export const MOCK_DATA_DEFAULT: IMockData = {
  delay: 300,
  disable: false,
  value: () => []
};
